import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
			<div style="text-align: justify;">
				<p class="mb-3">
					Longa vojaĝo atendis min. 
					Komenciĝis ĝi nokte, en plena mallumo. 
					Ĉirkaŭe estis iu vando, kiu ne lasis min moviĝi antaŭen; sed iel mi povis ŝanĝi la pozicion, etendi brakojn kaj krurojn… 
					ĝis certa grado. 
					Tamen, la mola elasta vando ĉiam baris miajn strebojn liberiĝi, kaj mi povis nur turni min en fermita ujo. 
					Estis siasenca «surloka moviĝo»; sed mi moviĝis ja, mi strebis al libero! 
				</p>
				
				<p class="mb-3">
					Tiu strebo konstante fariĝis pli kaj pli forta… 
					kaj jen, fin-fine! 
					Mi trovis la elirejon, mi forlasis malvastan ejon kaj alvenis al la ejo senlime vastega! 
					Ĉiuj vojoj jam estas malfermitaj al mi!
				</p>
				
				<p class="mb-3">
					Sed kion mi faru tie? 
					Ja daŭre ĉirkaŭas min la nokto. 
					Mi nenion scias pri tiu mondo, nenion komprenas, kaj dum longaj jaroj mi provis alkutimiĝi al ĝi. 
					Mi ellernis paŝi, ellernis paroli; poste mi edukiĝis en lernejo… sed kiel densa mallumo englutis min dum multaj lecionoj, 
					multaj interparoloj… 
					Mi ne komprenas! 
					Mi ne scias, por kio oni rakontas tion al mi, mi ne bezonas tion, mi ne vidas sencon en tio! 
					La obskuro densiĝas.
				</p>
				
				<p class="mb-3">
					Kaj jen venis IO, pri kio neniu klarigis, neniu rakontis; sed tio estis fortega impulso, kiu ĵetis min feroce kaj blinde… 
					Mi ne sciis, kion kaj kiel fari. 
					Mi iris ien, sen vojoj, nur palpe, serĉante kaj trovante ION. 
					Nokta vojaĝo…
				</p>
				
				<p class="mb-3">
					Nun mi jam estas plenaĝa kaj devas trovi mian propran vojon en la vivo. 
					Sed mi ne scias, kio okazas ĉirkaŭ mi, tenebro kovras ĉion, mi povas vidi nur mallarĝan lumstrion, 
					kiun sendas antaŭen miaj streboj kaj mia volo. 
					Ĉio alia, la tuta senmezure vasta, buntega, diversflanka realo ne ekzistas por mi, se mi pri ĝi ne scias. 
					Ni iras nokte; kiel trovi, kiu vojo estas nia? 
					Ĉiuj vojoj dronas en mallumo, kaj ni ne povas diveni, kien kondukos nin tiu, kiun ni elektis hazarde. 
					Ja ĉio estas nigra, kaj apenaŭ troviĝas vojsignoj sur la vojo de l’ vivo. 
				</p>
				
				<p class="mb-3">
					Lumas apartaj lanternetoj tie kaj tie. Estas «Torĉoj de la Vivo», Gvidantoj de l’ Homaro, grandaj pensuloj kaj verkistoj, 
					kiuj trovis sian vojon kaj povas prilumi ĝin por la sekvantoj – tiuj, kiuj ekdeziris sekvi. 
					Sed nemultas ili: ja la vojo estas neglata, la celo necerta. 
					Tiu, kiu ekbruligis la lumon, iris sian propran vojon; sed mi ja ne estu epigono, mi devas trovi MIAN propran!
				</p>
				
				<p class="mb-3">
					Sed kiel trovi ĝin? 
					Se mi rekte sekvos iun, mi atingus nur la celon de tiu unua, sed ne la mian! 
					Kaj se sur la montrita de li vasta vojo serĉi tion, kio logas ĝuste min, kio estas destinita ĝuste por mi, 
					– tiam mi tutegale devos devojiĝi de la vasta ŝoseo kaj serĉi mian propran vojeton, denove malluman kaj iritan de neniu, 
					kovritan de densa herbaro, arbustoj, eble kun dornoj!
				</p>
				
				<p class="mb-3">
					Ne, prefere mi ne turmentu min; mi kunfluiĝu kun tiu ĉi aro, kiu moviĝas ien… 
					La lumon mi preskaŭ ne vidas: ĝin ombras grandega amaso de irantaj tiudirekten; sed mi sentas ŝultrojn, kubutojn, koksojn de paŝantaj apude, 
					kaj ili ne lasos min erari, eliri el la kolono, ŝanĝi la direkton. 
					Ne gravas ja kien! 
					Gravas, ke mi iras kun la plejmulto, kaj jam ne devas en suferoj serĉi MIAN PROPRAN vojon! 
					Jen la vojo por ĈIUJ, kaj LA ĈIUJ ne povas erari! 
					Jen fin-fine mi trovis la vojon, kaj neniam plu mi forlasos tiun kunaron! 
					Jam mi ne devas serĉi kaj pensi! – ĉio ja estas solvita kaj klara! 
				</p>
				
				<p class="mb-3">
					Kaj tiel, en mallumo, mi daŭrigas mian vojaĝon. 
					Ĝis la fina mallumo.
				</p>
				
				<p class="mb-3">
					Nokta vojaĝo. 
				</p>


			</div>
    `
  )
}

const itemName = {
  esp: 'Nokta vojaĝo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
  }
}

export default item; 